export const MAIN_FUNCTION = 'main';
export const DEPLOY_METHOD = 'deploy';
export const PROPERTIES_PROPERTY = 'properties';
export const NORMAL_COMPLETION = 0;
export const THROW_COMPLETION = 1;
export const BREAK_COMPLETION = 2;
export const CONTINUE_COMPLETION = 3;
export const FINALLY_COMPLETION = 4;
export const DEFAULT_CONTRACT_PROPERTIES = {
    name: '',
    codeVersion: '1.0',
    author: '',
    email: '',
    description: '',
};
export var Decorator;
(function (Decorator) {
    Decorator["constant"] = "constant";
    Decorator["send"] = "send";
    Decorator["sendUnsafe"] = "sendUnsafe";
    Decorator["receive"] = "receive";
    Decorator["claim"] = "claim";
})(Decorator || (Decorator = {}));
export const isDecorator = (value) => Decorator[value] !== undefined;
export const DECORATORS = new Set(Object.values(Decorator));
export const DECORATORS_ARRAY = Object.values(Decorator);
export var ContractPropertyName;
(function (ContractPropertyName) {
    ContractPropertyName["deploy"] = "deploy";
    ContractPropertyName["processedTransactions"] = "processedTransactions";
    ContractPropertyName["claimedTransactions"] = "claimedTransactions";
    ContractPropertyName["address"] = "address";
    ContractPropertyName["properties"] = "properties";
    ContractPropertyName["refundAssets"] = "refundAssets";
    ContractPropertyName["completeSend"] = "completeSend";
    ContractPropertyName["deployed"] = "deployed";
    ContractPropertyName["approveUpgrade"] = "approveUpgrade";
    ContractPropertyName["upgrade"] = "upgrade";
    ContractPropertyName["destroy"] = "destroy";
})(ContractPropertyName || (ContractPropertyName = {}));
export const VIRTUAL_PROPERTIES = new Set([ContractPropertyName.deploy]);
export const RESERVED_PROPERTIES = new Set([
    ContractPropertyName.refundAssets,
    ContractPropertyName.completeSend,
    ContractPropertyName.upgrade,
    ContractPropertyName.destroy,
]);
export const BUILTIN_PROPERTIES = new Set([
    ContractPropertyName.processedTransactions,
    ContractPropertyName.claimedTransactions,
    ContractPropertyName.address,
    ContractPropertyName.deployed,
]);
export const IGNORED_PROPERTIES = new Set([ContractPropertyName.properties]);

//# sourceMappingURL=constants.js.map
